import React from "react";
import { Chat, Container, Image, ImageContainer, Inner, Text } from "./styles";

const Barcode = () => {
  return (
    <Container>
      <Inner>
        <ImageContainer>
          <Image src="/img/download/qrcode.png" alt="download" />
        </ImageContainer>
        <Chat>
          <Text>
            <b>DAPPS PROCESSED</b>
          </Text>
        </Chat>
      </Inner>
    </Container>
  );
};

export default Barcode;
